module.exports = __webpack_public_path__ + "img/logistics-truck.c0705c59.svg";